import { API_CALL_STATUS, FIELD_STATUS, FORM_STATUS } from '../status';
import {
    REINITIALIZE,
    ID_UPLOAD_RESET_VALUE,
    ID_UPLOAD_SET_VALUE,
    ID_UPLOAD_SET_VALID,
    KRA_PIN_UPLOAD_SET_VALUE,
    KRA_PIN_UPLOAD_RESET_VALUE,
    KRA_PIN_UPLOAD_SET_VALID,
    FORM_VALID_PERSONAL_ACCIDENT_DOCUMENTS_FORM,
    FORM_INVALID_PERSONAL_ACCIDENT_DOCUMENTS_FORM,
    SELECTED_FORM_SET_VALUE,
    API_INITIAL_TRANSITION_DOCUMENTS_FORM,
    API_PENDING_TRANSITION_DOCUMENTS_FORM,
    API_SUCCESS_TRANSITION_DOCUMENTS_FORM,
    API_FAILURE_TRANSITION_DOCUMENTS_FORM
} from '../../actions/personalAccident/Documents';

export const initDocuments = {
    formStatus: FORM_STATUS.INVALID,
    dropOffDetails: null,
    personalDetailsReferenceData: null,
    apiCallStatus: null,
    selectedForm: 'uploadDocuments',
    form: {
        //new
        idUpload: { value: null, error: null, status: null },
        kraPinUpload: { value: null, error: null, status: null },
    },
};

export default (state = initDocuments, action) => {
    const mapError = (error) => (error ? FIELD_STATUS.ERROR : FIELD_STATUS.VALID);
    const updateFormField = (fieldId, update) => ({
        ...state,
        form: {
            ...state.form,
            [fieldId]: update(state.form[fieldId]),
        },
    });

    switch (action.type) {
        case FORM_VALID_PERSONAL_ACCIDENT_DOCUMENTS_FORM:
            return { ...state, formStatus: FORM_STATUS.VALID };

        case FORM_INVALID_PERSONAL_ACCIDENT_DOCUMENTS_FORM:
            return { ...state, formStatus: FORM_STATUS.INVALID };

        // ID UPLOAD
        case ID_UPLOAD_SET_VALUE:
            return updateFormField('idUpload', (field) => ({
                ...field,
                value: action.value,
            }));

        case ID_UPLOAD_SET_VALID:
            return updateFormField('idUpload', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case ID_UPLOAD_RESET_VALUE:
            return updateFormField('idUpload', (field) => ({
                ...field,
                value: null,
            }));

        // KRA PIN UPLOAD
        case KRA_PIN_UPLOAD_SET_VALUE:
            return updateFormField('kraPinUpload', (field) => ({
                ...field,
                value: action.value,
            }));

        case KRA_PIN_UPLOAD_SET_VALID:
            return updateFormField('kraPinUpload', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case KRA_PIN_UPLOAD_RESET_VALUE:
            return updateFormField('kraPinUpload', (field) => ({
                ...field,
                value: null,
            }));

        case SELECTED_FORM_SET_VALUE:
            return { ...state, selectedForm: action.value };

         //    API Calls
        case API_INITIAL_TRANSITION_DOCUMENTS_FORM:
            return { ...state, apiCallStatus: null};
        case API_PENDING_TRANSITION_DOCUMENTS_FORM:
            return { ...state, apiCallStatus: API_CALL_STATUS.PENDING };
        case API_SUCCESS_TRANSITION_DOCUMENTS_FORM:
            return { ...state, apiCallStatus: API_CALL_STATUS.SUCCESS };
        case API_FAILURE_TRANSITION_DOCUMENTS_FORM:
            return { ...state, apiCallStatus: API_CALL_STATUS.FAILURE };

        // Reset the state
        case REINITIALIZE:
            return initDocuments;
        default:
            return state;
    }
};
